import type { Form } from 'state/secondaryMarket/shared/form/form.model';
import type { ChangeTrackForm } from 'state/secondaryMarket/shared/form/input/input.model';
import type { Collection } from 'state/utils/types';

export interface LimitOrderForm extends Form {
  limit?: number;
  salesMarginAdjustment?: number;
}

export type LimitOrderInputForm = ChangeTrackForm<LimitOrderForm>;

export type LimitOrderFormField = keyof LimitOrderForm;
export type LimitOrderFormMap = Collection<LimitOrderInputForm>;

export const initialLimitOrderFormMap: LimitOrderFormMap = {};
export const initialLimitOrderForm: LimitOrderInputForm = {
  tradeSizeInputMode: undefined,
  changes: [],
};
